{
  "it": {
    "models": {
      "name": "Navi",
      "model": {
        "metrics": {
          "base": "Base",
          "crew": "Equipaggio",
          "info": "Info",
          "levels": "Livelli",
          "speed": "Velocità"
        },
        "focus": "Specializzazione",
        "classification": "Classificazione",
        "size": "Dimensione",
        "beam": "Larghezza",
        "cargo": "Carico",
        "crew": "Equipaggio",
        "speed": "Velocità",
        "minCrew": "Equipaggio min.",
        "maxCrew": "Equipaggio max.",
        "scmSpeed": "SCM Speed",
        "maxSpeed": "Velocità max.",
        "scm": "SCM",
        "max": "Max",
        "groundMaxSpeed": "Velocità max.",
        "groundReverseSpeed": "Velocità di retromarcia",
        "pitch": "Pitch",
        "yaw": "Yaw",
        "roll": "Roll",
        "price": "Prezzo",
        "groundAcceleration": "Accelerazione",
        "groundDecceleration": "Decelerazione",
        "scmSpeedAcceleration": "Zero a SCM",
        "scmSpeedDecceleration": "SCM a Zero",
        "compare": {
          "groundMaxSpeed": "Velocità a terra max.",
          "groundReverseSpeed": "Velocità a terra in retromarcia",
          "groundAcceleration": "Accelerazione a terra",
          "groundDecceleration": "Decelerazione a terra"
        },
        "quantumFuelTankSize": "Carburante Quantum",
        "hydrogenFuelTankSize": "Carburante",
        "pledgePrice": "Prezzo Pledge",
        "height": "Altezza",
        "length": "Lunghezza",
        "mass": "Massa",
        "manufacturer": "Produttore",
        "hardpoints": "Punti di montaggio",
        "weapons": "Armi",
        "equipment": "Equipaggiamento",
        "variants": "Varianti",
        "productionStatus": "Stato di produzione",
        "propulsion": "Propulsione",
        "modular": "Modulare",
        "soldAt": "Venduto a?",
        "rentalAt": "Noleggiato a?",
        "lastUpdatedAt": "Ultimo aggiornamento?",
        "loaners": "Prestiti",
        "paints": "Verniciature",
        "modules": "Moduli",
        "modulePackages": "Pacchetti di moduli",
        "upgrades": "Kit di upgrade",
        "brochure": "Brochure",
        "onSale": "In vendita",
        "salesPage": "Pagina di vendita",
        "addons": "Moduli e kit di upgrade",
        "productionStatuses": {
          "notAvailable": "N/A",
          "ready": "Pronto per l'hangar",
          "announced": "Annunciato"
        }
      }
    }
  }
}
